export const onBundleProductFragment = /* GraphQL */ `
  ... on BundleProduct {
    dynamic_sku
    dynamic_price
    dynamic_weight
    is_custom_kit
    is_flavour_kit
    price_view
    ship_bundle_items
    bundle_main_price {
      price
      final_price
      discount
    }
    items {
      uid
      title
      required
      type
      position
      sku
      ooka_product_option
      options {
        uid
        quantity
        position
        is_default
        price
        price_type
        can_change_quantity
        label
        product {
          uid
          name
          sku
          stock_status
          flavour
          flavour_text
          is_tobacco_product
          ooka_product_type
          thumbnail {
            label
            url
          }
          small_image {
            label
            url
          }
          kit_image {
            label
            url
          }
          media_gallery {
            __typename
            url
            disabled
            label
            position
            ... on ProductVideo {
              video_content {
                media_type
                video_provider
                video_url
                video_title
                video_description
                video_metadata
                __typename
              }
              __typename
            }
          }
          price_range {
              minimum_price {
                regular_price {
                  __typename
                  value
                  currency
                }
                final_price {
                  __typename
                  value
                  currency
                }
                discount {
                  __typename
                  amount_off
                }
              }
            }
            short_description {
                __typename
                html
  }
          __typename
        }
      }
    }
  }
`
